import { Check, type LucideIcon, Sparkles } from 'lucide-react'
import type { ReactNode } from 'react'

export function IllustrationFrame({ label, children }: { label: string; children: ReactNode }) {
  return (
    <svg viewBox="0 0 680 300" role="img" aria-label={label} className="block w-full">
      <circle cx="374" cy="147" r="141" className="fill-primary/5" />
      <circle cx="374" cy="147" r="111" className="fill-none stroke-primary/10" />
      {children}
    </svg>
  )
}

export function AgentCore({ label }: { label: string }) {
  return (
    <g>
      <rect
        x="285"
        y="112"
        width="66"
        height="66"
        rx="23"
        className="fill-primary/10 stroke-primary/20"
      />
      <rect x="293" y="120" width="50" height="50" rx="17" className="fill-foreground" />
      <Sparkles x="305" y="132" width="26" height="26" className="text-background" />
      <text
        x="318"
        y="201"
        textAnchor="middle"
        className="fill-primary-strong text-2xs font-semibold"
      >
        {label}
      </text>
    </g>
  )
}

export function GraphicCard({
  card,
}: {
  card: { x: number; y: number; label: string; icon: LucideIcon }
}) {
  const Icon = card.icon
  return (
    <g transform={`translate(${card.x} ${card.y})`}>
      <rect width="174" height="58" rx="12" className="fill-card stroke-primary/40" />
      <rect x="10" y="12" width="34" height="34" rx="9" className="fill-primary/10" />
      <Icon x="18" y="20" width="18" height="18" className="text-primary-strong" />
      <text x="54" y="33" className="fill-foreground text-2xs font-medium">
        {card.label}
      </text>
    </g>
  )
}

export function VerifiedPill({ label, y = 236 }: { label: string; y?: number }) {
  return (
    <g transform={`translate(437 ${y})`}>
      <rect width="186" height="28" rx="14" className="fill-primary/10 stroke-primary/20" />
      <Check x="12" y="7" width="14" height="14" className="text-primary-strong" />
      <text x="34" y="18" className="fill-primary-strong text-3xs font-medium">
        {label}
      </text>
    </g>
  )
}

/** A card with a second, slightly turned copy behind it: the source artifact every slide starts from. */
export function StackedCard({
  x,
  y,
  width,
  height,
  rx = 12,
}: {
  x: number
  y: number
  width: number
  height: number
  rx?: number
}) {
  const pivot = `${x + width / 2} ${y + 6 + height / 2}`
  return (
    <>
      <rect
        x={x}
        y={y + 6}
        width={width}
        height={height}
        rx={rx}
        transform={`rotate(-6 ${pivot})`}
        className="fill-muted stroke-border"
      />
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        rx={rx}
        className="fill-card stroke-primary/40"
      />
    </>
  )
}

export function ConnectionLines({ d }: { d: string }) {
  return <path d={d} className="fill-none stroke-primary/50" strokeWidth="1.5" />
}
